module.exports = __webpack_public_path__ + "img/vpn-3.0785752e.jpg";